// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2X-dT","log":"ModalInventoryLogs_log__2MXNA","date":"ModalInventoryLogs_date__J8Id5","userName":"ModalInventoryLogs_userName__1jPbP"};